import * as React from 'react'

import * as Common from '@rushplay/common'
import { lazy as loadable } from '@loadable/component'
import { useI18n } from '@rushplay/i18n'

import * as Http from './http'
import * as Icons from './icons'
import * as Theming from './theming'
import { Button } from './button'
import { GlobalStyles } from './global-styles'
import { HtmlContent } from './html-content'

const SupportChat = loadable(() => import('./support-chat'))

function RecoveryInfo() {
  Http.useResponseStatus(401)
  const i18n = useI18n()
  const [isReloading, setReloading] = React.useState(false)

  function handleRefresh() {
    setReloading(true)
    !isReloading && window.location.reload()
  }

  return (
    <Theming.Alternative>
      <Common.Box
        flexGrow="1"
        flexShrink="1"
        flexDirection="column"
        display="flex"
      >
        <Common.Space py={1} px={2}>
          <img src="/images/boom-logo-long.svg" alt="boom" loading="lazy" />
        </Common.Space>
        <Common.Box
          display="flex"
          backgroundColor="g-bg"
          flexGrow="1"
          flexShrink="1"
          flexBasis="0"
          padding={[null, 4]}
          justifyContent="center"
          alignItems={[null, 'flex-start']}
        >
          <Common.Box
            bg="g-bg"
            borderRadius={[null, null, 1]}
            boxShadow={[null, 0]}
            color="g-text"
            display="flex"
            flexDirection="column"
            alignItems="center"
            p={2}
            textAlign="center"
            maxWidth={['100%', '500px']}
            lineHeight="1.25"
            fontSize={1}
            flexGrow="1"
          >
            <Common.Box color="secondary" fontSize="32px">
              <Icons.Error />
            </Common.Box>
            <Common.Box py={1} maxWidth="400px">
              <HtmlContent
                html={{
                  __html: i18n.translate('error-recovery-page.info'),
                }}
              />
            </Common.Box>
            <Button onClick={handleRefresh}>
              {isReloading ? (
                <Common.Box display="inline" px={1}>
                  <Icons.Spinner />
                </Common.Box>
              ) : (
                <React.Fragment>
                  <Common.Box display="inline" pr="0">
                    <Icons.Refresh />
                  </Common.Box>
                  {i18n.translate('error-recovery-page.refresh')}
                </React.Fragment>
              )}
            </Button>
          </Common.Box>
        </Common.Box>
      </Common.Box>
    </Theming.Alternative>
  )
}

export function ClientErrorPage() {
  return (
    <React.Fragment>
      <GlobalStyles />
      <Common.Box
        display="flex"
        minHeight="fill-available"
        flexDirection={['column', 'row']}
      >
        <Common.Box flexGrow="1" overflowX="hidden">
          <Common.Box
            minHeight={['calc(var(--window-inner-height, 100vh))', '100vh']}
            display="flex"
          >
            <RecoveryInfo />
          </Common.Box>
          <SupportChat visibleAt={0} hidden={false} />
        </Common.Box>
      </Common.Box>
    </React.Fragment>
  )
}

// For loadable/components
export default ClientErrorPage
